import { render, staticRenderFns } from "./frontQuienesSomos.vue?vue&type=template&id=872d83d6&scoped=true&"
import script from "./frontQuienesSomos.vue?vue&type=script&lang=js&"
export * from "./frontQuienesSomos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872d83d6",
  null
  
)

export default component.exports